import { useQuery } from "@tanstack/react-query";
import { accountTermsApi, type AccountTermsSummaryDto } from "@/lib/clients-accounts";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";

export type { AccountTermsSummaryDto };

export interface PaymentTermsPickerProps {
  value: number | null;
  onChange: (termsId: number | null) => void;
  placeholder?: string;
}

export function PaymentTermsPicker({
  value,
  onChange,
  placeholder,
}: PaymentTermsPickerProps) {
  const { data, isLoading } = useQuery({
    queryKey: ["account-terms"],
    queryFn: () => accountTermsApi.list(),
    staleTime: 60_000,
  });

  const items = data?.items ?? [];

  return (
    <Select
      value={value !== null ? String(value) : undefined}
      onValueChange={(v) => onChange(v === "__none__" ? null : Number(v))}
    >
      <SelectTrigger>
        <SelectValue
          placeholder={isLoading ? "Loading…" : (placeholder ?? "Select payment terms")}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">(none)</SelectItem>
        {items.map((t) => (
          <SelectItem key={t.termsId} value={String(t.termsId)}>
            {t.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
